export const MIN_THRESHOLD_YEARS = 100;
export const MAX_THRESHOLD_YEARS = 100;
